import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TextInputController } from '@/components/FormElements'
import { useAppState } from '@/features/app/hooks'
import { DetailsFormSection } from '@/features/profile/components/FormSections/BabysitterProfileFormSections'
import { NormalizeUtils } from '@/utils'

export type GeneralFormValues = {
  first_name: string
  last_name: string
  phone: string
  birthday: Date
  city_id: number | string | null
  occupation_area: string
  bio: string
}

export const GeneralForm = () => {
  const { t } = useTranslation()
  const {
    appState: { mobileView },
  } = useAppState()

  const { control } = useFormContext<GeneralFormValues>()

  return (
    <>
      <TextInputController
        control={control}
        name={'first_name'}
        id={'first_name'}
        label={t('first_name')}
        placeholder={t('first_name')}
        size={mobileView ? 'md' : 'lg'}
        mb={mobileView ? '0' : 'md'}
      />

      <TextInputController
        control={control}
        name={'last_name'}
        id={'last_name'}
        label={t('last_name')}
        placeholder={t('last_name')}
        size={mobileView ? 'md' : 'lg'}
        mb={mobileView ? '0' : 'md'}
      />

      <TextInputController
        control={control}
        name={'phone'}
        id={'phone'}
        label={t('phone')}
        placeholder={t('phone')}
        size={mobileView ? 'md' : 'lg'}
        mb={mobileView ? '0' : 'md'}
        normalize={NormalizeUtils.phone}
      />

      <DetailsFormSection />
    </>
  )
}
